<template>
<div>
  <canvas id="chart-manual" height="100"></canvas>
</div>
</template>

<script>
import Chart from 'chart.js';
import ChartDataManual from '@/chart-data-manual.js';
export default {
    name: 'ProductsMetaChart',
    data() {
	return {
	    ChartDataManual
	}
    },
    mounted() {
	this.createChart('chart-manual', this.ChartDataManual);
    },
    methods: {
	createChart(chartId, chartData) {
	    const ctx = document.getElementById(chartId);
	    const myChart = new Chart(ctx, {
		type: chartData.type,
		data: chartData.data,
		options: chartData.options,
	    });
	}
    }
}
</script>
